import React from 'react'
import AboutUsSection from '../../components/AboutUs/AboutUs'
import FooterComp from '../../components/Footer/FooterComp'

const About = () => {
  return (
    <div>
      <AboutUsSection/>
       <FooterComp/>
    </div>
  )
}

export default About

